import Typography from '../typography/Typography'
// import { Typography } from '@mui/material';
import './icon.text.wrapper.scss'

// props
// direction = flex | flex-column
// icon = normal | profile

const IconText = ({
  icon,
  profileImage = '',
  iconType = 'normal',
  text,
  direction = 'flex',
  textType,
  textWeight,
  textColor,
}) => {

  return (
    <div className={`icon-text-wrapper flex justify-left align-center ${direction}`}>
      {
      //   isIcon &&<div
      //   className={`icon-wrapper flex justify-center align-center ${iconType}`}
      //   style={{
      //     backgroundImage: iconType === 'profile' ? `url(${profileImage})` : 'none',
      //   }}
      // >
      //   {iconType === 'normal' && icon}
      // </div>
      }
      
      <div className='text-wrapper'>
        <Typography transform='capitalize' textColor={textColor} textType={textType} textWeight={textWeight} className={`sidebar-btn-name ${textColor == "white" ? "color-white" : "color-black"}`}>
        <div
        className={`icon-wrapper flex justify-center align-center ${iconType}`}
        style={{
          backgroundImage: iconType === 'profile' ? `url(${profileImage})` : 'none',
        }}
      >
        {iconType === 'normal' && icon}
      </div> <p>{text}</p>
        </Typography>
      </div>
    </div>
  )
}

export default IconText
